/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ErrorCode } from '../modules/lxs-create-order/lxs-create-order.data';
import { trackedAction } from '../utilities/track-execution-time';
import { ensureAuthenticated } from '../utilities/is-authenticated';

/**
 * GetSoldToIds Input Action
 */
export class GetSoldToIdsInput implements Msdyn365.IActionInput {
    public timestamp: string;
    constructor() {
        this.timestamp = new Date().getTime().toString();
    }

    public getCacheKey = () => `GetSoldToIds-${this.timestamp}`;
    public getCacheObjectType = () => 'GetSoldToIds';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetSoldToIdsData {
    '@odata.context'?: string;
    value?: string[];
    error?: ErrorCode;
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetSoldToIdsInput();
};

async function action(_: GetSoldToIdsInput, ctx: Msdyn365.IActionContext): Promise<any> {
    ensureAuthenticated(ctx);
    const response = await Msdyn365.sendRequest<IGetSoldToIdsData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetSoldToIds(language='${ctx.requestContext.locale}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );

    if (response.status === 200 && response.data) {
        return {
            ...response.data
        };
    } else {
        return { result: { value: [] }, error: { errorCode: response.status, errorText: response.statusText } };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetSoldToIdsData>>((input, ctx) => trackedAction(action, input, ctx, 'GetSoldToIds')),
    id: 'GetSoldToIds',
    input: createInput
});
